import React, { useState, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { gritComponentStyles } from './gritComponentStyles';
import cn from 'clsx';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import Button from '@mui/material/Button';
import {
  ClaimList,
  IOClaimComponent,
  DisplayClaimComponent,
  PersistedClaimComponent,
  ClaimTransformationList,
  ClaimTransformationComponent,
  ValidationTechnicalProfileList,
  RestVTPEditComponent,
  AADVTPEditComponent,
  ValidationTPAddComponent,
  ImpactAnalysisModalComponent,
} from '.';
import { ClaimsTransformation, ValidationTP, InputClaim } from '../../xmlParsing/interfaces';
import {
  init_DisplayClaim,
  init_PersistedClaim,
  init_InputClaim,
  init_OutputClaim,
  init_NonInteractiveTechnicalProfile,
} from '../../xmlParsing/initInterfaces';
import {
  getTransformationConfig,
  getClaimTransformations,
  addDuplicateState,
  deleteOperations,
  replaceDuplicateState,
  discardDuplicateState,
} from '../../store';
import { getTPType } from '../../utils/utils';
import { TooltipComponent } from '../uiComponents';
import MetadataGeneratorComponent from './metadataGenerator';
import CONSTANTS from '../../constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import useTPHook from './useTPHook';
interface technicalProfileProps {
  parentTP: string;
  className?: string;
  protocolName: string;
  closeTechnicalProfile: any;
  updateParent?: any;
  selectedTP: string;
}

function TechnicalProfile({
  parentTP,
  protocolName,
  selectedTP,
  updateParent,
  closeTechnicalProfile,
  className,
}: technicalProfileProps) {
  const dispatch = useDispatch();
  const transformationConfig = useSelector(getTransformationConfig);
  const allClaimTransformations: Record<string, ClaimsTransformation> = useSelector(getClaimTransformations);
  const classes = gritComponentStyles();
  const {
    actionData,
    rightData,
    claimsTransformationsList,
    validateTPData,
    show,
    setShow,
    setRightData,
    onChangeLabel,
    validateSelfAssertedProfile,
    onCloseRight,
    updateParentTP,
    checkBeforeUpdate,
    repTechnicalProfile,
  } = useTPHook(protocolName, selectedTP, closeTechnicalProfile, parentTP, updateParent);

  return (
    <>
      <div className={cn(classes.popup, classes.selfAssertedPopup, className && classes.validationPopup)}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>
            <div className={classes.actionName}>Label</div>
            <div>
              {actionData && (
                <input
                  className={classes.input}
                  type="text"
                  onChange={onChangeLabel}
                  value={actionData['displayName'] || ''}
                />
              )}
            </div>
            <div>
              {actionData && getTPType(actionData.protocol, actionData.metadata) + ' (' + actionData['id'] + ') '}
            </div>
          </div>
          <div>
            <ClearOutlinedIcon onClick={() => validateSelfAssertedProfile()} className={classes.delete} />
          </div>
        </div>

        <div className={cn(classes.flexRow, classes.policyBody)}>
          {actionData && (
            <div className={classes.showPolicy}>
              {actionData.hasOwnProperty(CONSTANTS.VALIDATION_METADATA) && (
                <>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.VALIDATION_METADATA,
                        mode: 'edit',
                        list: [],
                        data: actionData[CONSTANTS.VALIDATION_METADATA],
                      });
                    }}
                  >
                    View / Edit Metadata &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.Metadata.header}
                      desc={CONSTANTS.HELPTEXT.Metadata.description}
                      link={CONSTANTS.HELPTEXT.Metadata.link}
                    />
                  </Button>
                </>
              )}

              {actionData.hasOwnProperty(CONSTANTS.INPUT_CLAIMS) && (
                <>
                  <div className={classes.heading}>
                    Input Claims &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.InputClaims.header}
                      desc={CONSTANTS.HELPTEXT.InputClaims.description}
                      link={CONSTANTS.HELPTEXT.InputClaims.link}
                    />
                  </div>
                  <ClaimList
                    list={actionData[CONSTANTS.INPUT_CLAIMS]}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.INPUT_CLAIMS,
                        id: val,
                        mode: 'edit',
                        list: [],
                        data: actionData[CONSTANTS.INPUT_CLAIMS].filter(
                          (el: InputClaim) => el.claimTypeReferenceId === val,
                        )[0],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(deleteOperations({ type: CONSTANTS.INPUT_CLAIMS, protocolName, selectedTP, id: val }));
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />

                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.INPUT_CLAIMS,
                        mode: 'add',
                        list: actionData[CONSTANTS.INPUT_CLAIMS],
                        data: init_InputClaim(),
                      });
                    }}
                  >
                    Add INPUT CLAIMS
                  </Button>
                </>
              )}
              {actionData.hasOwnProperty(CONSTANTS.DISPLAY_CLAIMS) && (
                <>
                  <div className={classes.heading}>
                    Display Claims &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.DisplayClaims.header}
                      desc={CONSTANTS.HELPTEXT.DisplayClaims.description}
                      link={CONSTANTS.HELPTEXT.DisplayClaims.link}
                    />
                  </div>
                  <ClaimList
                    list={actionData[CONSTANTS.DISPLAY_CLAIMS]}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.DISPLAY_CLAIMS,
                        id: val,
                        mode: 'edit',
                        data: actionData[CONSTANTS.DISPLAY_CLAIMS].filter(
                          (el: InputClaim) => el.claimTypeReferenceId === val,
                        )[0],
                        list: [],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(deleteOperations({ type: CONSTANTS.DISPLAY_CLAIMS, protocolName, selectedTP, id: val }));
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />

                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.DISPLAY_CLAIMS,
                        mode: 'add',
                        data: init_DisplayClaim(),
                        list: actionData[CONSTANTS.DISPLAY_CLAIMS],
                      });
                    }}
                  >
                    Add DISPLAY CLAIMS
                  </Button>
                </>
              )}
              {getTPType(actionData.protocol, actionData.metadata) === 'AAD-Write' &&
                actionData.hasOwnProperty(CONSTANTS.PERSISTED_CLAIMS) && (
                  <>
                    <div className={classes.heading}>
                      Persisted Claims &nbsp;&nbsp;
                      <TooltipComponent
                        title={CONSTANTS.HELPTEXT.PersistedClaims.header}
                        desc={CONSTANTS.HELPTEXT.PersistedClaims.description}
                        link={CONSTANTS.HELPTEXT.PersistedClaims.link}
                      />
                    </div>
                    <ClaimList
                      list={actionData[CONSTANTS.PERSISTED_CLAIMS]}
                      onEditHandler={(val: string) => {
                        setRightData({
                          type: CONSTANTS.PERSISTED_CLAIMS,
                          id: val,
                          mode: 'edit',
                          data: actionData[CONSTANTS.PERSISTED_CLAIMS].filter(
                            (el: InputClaim) => el.claimTypeReferenceId === val,
                          )[0],
                          list: [],
                        });
                      }}
                      onDeleteHandler={(val: string) => {
                        dispatch(
                          deleteOperations({ type: CONSTANTS.PERSISTED_CLAIMS, protocolName, selectedTP, id: val }),
                        );
                        Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                      }}
                    />

                    <Button
                      variant="contained"
                      onClick={() => {
                        setRightData({
                          type: CONSTANTS.PERSISTED_CLAIMS,
                          mode: 'add',
                          data: init_PersistedClaim(),
                          list: actionData[CONSTANTS.PERSISTED_CLAIMS],
                        });
                      }}
                    >
                      Add PERSISTED CLAIMS
                    </Button>
                  </>
                )}
              {actionData.hasOwnProperty(CONSTANTS.OUTPUT_CLAIMS) && (
                <>
                  <div className={classes.heading}>
                    Output Claims &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.OutputClaims.header}
                      desc={CONSTANTS.HELPTEXT.OutputClaims.description}
                      link={CONSTANTS.HELPTEXT.OutputClaims.link}
                    />
                  </div>
                  <ClaimList
                    list={actionData[CONSTANTS.OUTPUT_CLAIMS]}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.OUTPUT_CLAIMS,
                        id: val,
                        mode: 'edit',
                        list: [],
                        data: actionData[CONSTANTS.OUTPUT_CLAIMS].filter(
                          (el: InputClaim) => el.claimTypeReferenceId === val,
                        )[0],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(deleteOperations({ type: CONSTANTS.OUTPUT_CLAIMS, protocolName, selectedTP, id: val }));
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.OUTPUT_CLAIMS,
                        mode: 'add',
                        data: init_OutputClaim(),
                        list: actionData[CONSTANTS.OUTPUT_CLAIMS],
                      });
                    }}
                  >
                    Add OUTPUT CLAIMS
                  </Button>
                </>
              )}
              {actionData.hasOwnProperty(CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS) && (
                <>
                  <div className={classes.heading}>
                    Input Claim Transformation &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.InputClaimsTransformations.header}
                      desc={CONSTANTS.HELPTEXT.InputClaimsTransformations.description}
                      link={CONSTANTS.HELPTEXT.InputClaimsTransformations.link}
                    />
                  </div>

                  <ClaimTransformationList
                    list={actionData[CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS].filter((el: string) =>
                      claimsTransformationsList.hasOwnProperty(el),
                    )}
                    onEditHandler={(val: string) => {
                      const transmethod = allClaimTransformations[val]['transformationmethod'];
                      transformationConfig.hasOwnProperty(transmethod)
                        ? setRightData({
                            type: CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS,
                            id: val,
                            mode: 'edit',
                            data: claimsTransformationsList[val],
                          })
                        : window.alert(
                            val +
                              ' has a transformation method ' +
                              transmethod +
                              ' which is not defined by the application.',
                          );
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(
                        deleteOperations({
                          type: CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS,
                          protocolName,
                          selectedTP,
                          id: val,
                        }),
                      );
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS,
                        mode: 'add',
                        list: actionData[CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS],
                        data: actionData[CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS].filter((el: string) =>
                          claimsTransformationsList.hasOwnProperty(el),
                        ),
                      });
                    }}
                  >
                    Add INPUT CLAIMS TRANSFORMATION
                  </Button>
                </>
              )}
              {actionData.hasOwnProperty(CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS) && (
                <>
                  <div className={classes.heading}>
                    Output Claim Transformation &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.OutputClaimsTransformations.header}
                      desc={CONSTANTS.HELPTEXT.OutputClaimsTransformations.description}
                      link={CONSTANTS.HELPTEXT.OutputClaimsTransformations.link}
                    />
                  </div>

                  <ClaimTransformationList
                    list={actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].filter((el: string) =>
                      claimsTransformationsList.hasOwnProperty(el),
                    )}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                        id: val,
                        mode: 'edit',
                        data: claimsTransformationsList[val],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(
                        deleteOperations({
                          type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                          protocolName,
                          selectedTP,
                          id: val,
                        }),
                      );
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />

                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                        mode: 'add',
                        list: actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS],
                        data: actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].filter((el: string) =>
                          claimsTransformationsList.hasOwnProperty(el),
                        ),
                      });
                    }}
                  >
                    Add OUTPUT CLAIMS TRANSFORMATION
                  </Button>
                </>
              )}
              {actionData.hasOwnProperty(CONSTANTS.VALIDATION_TECHNICAL_PROFILES) && (
                <>
                  <div className={classes.heading}>
                    Validation Technical Profile &nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.ValidationTechnicalProfiles.header}
                      desc={CONSTANTS.HELPTEXT.ValidationTechnicalProfiles.description}
                      link={CONSTANTS.HELPTEXT.ValidationTechnicalProfiles.link}
                    />
                  </div>
                  <ValidationTechnicalProfileList
                    list={actionData[CONSTANTS.VALIDATION_TECHNICAL_PROFILES]}
                    onOpenHandler={(val: string, vtpType: 'REST' | 'AAD' | 'OpenId') => {
                      setRightData({
                        type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
                        id: val,
                        mode: 'edit-' + vtpType,
                        selectedTP: val,
                      });
                      dispatch(addDuplicateState());
                      setShow('popup');
                    }}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
                        id: val,
                        mode: 'edit',
                        data: actionData[CONSTANTS.VALIDATION_TECHNICAL_PROFILES].filter(
                          (el: ValidationTP) => el.id === val,
                        )[0],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(
                        deleteOperations({
                          type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
                          protocolName,
                          selectedTP,
                          id: val,
                        }),
                      );
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
                        mode: 'add',
                        list: actionData[CONSTANTS.VALIDATION_TECHNICAL_PROFILES],
                        data: init_NonInteractiveTechnicalProfile(),
                      });
                    }}
                  >
                    Add Validation Technical Profile
                  </Button>
                </>
              )}
            </div>
          )}

          {rightData && (
            <div className={classes.editPolicy}>
              {[CONSTANTS.VALIDATION_METADATA].includes(rightData['type']) && (
                <MetadataGeneratorComponent
                  metadata={CONSTANTS.getMetaData(getTPType(actionData.protocol, actionData.metadata))}
                  data={rightData?.data}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.INPUT_CLAIMS, CONSTANTS.OUTPUT_CLAIMS].includes(rightData['type']) && (
                <IOClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.DISPLAY_CLAIMS].includes(rightData['type']) && (
                <DisplayClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.PERSISTED_CLAIMS].includes(rightData['type']) && (
                <PersistedClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS, CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].includes(
                rightData['type'],
              ) && (
                <ClaimTransformationComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.VALIDATION_TECHNICAL_PROFILES].includes(rightData['type']) && (
                <>
                  {rightData['mode'] === 'edit-REST' && show === 'popup' && (
                    <RestVTPEditComponent
                      parentTP={actionData['id']}
                      protocolName={CONSTANTS.PROTOCOL_NAME.otherProfile}
                      updateParent={updateParentTP}
                      selectedTP={rightData?.selectedTP}
                      closeTechnicalProfile={(data: any) => {
                        data != null ? dispatch(replaceDuplicateState()) : dispatch(discardDuplicateState());
                        setShow('');
                      }}
                    />
                  )}
                  {rightData['mode'] === 'edit-AAD' && show === 'popup' && (
                    <AADVTPEditComponent
                      parentTP={actionData['id']}
                      selectedTP={rightData?.selectedTP}
                      protocolName={CONSTANTS.PROTOCOL_NAME.otherProfile}
                      updateParent={updateParentTP}
                      closeTechnicalProfile={(data: any) => {
                        data != null ? dispatch(replaceDuplicateState()) : dispatch(discardDuplicateState());
                        setShow('');
                      }}
                    />
                  )}
                  {rightData['mode'] === 'edit-OpenId' && show === 'popup' && (
                    <TechnicalProfile
                      parentTP={actionData['id']}
                      className="validationPopup"
                      protocolName={CONSTANTS.PROTOCOL_NAME.otherProfile}
                      selectedTP={rightData?.selectedTP}
                      updateParent={updateParentTP}
                      closeTechnicalProfile={(data: any) => {
                        data != null ? dispatch(replaceDuplicateState()) : dispatch(discardDuplicateState());
                        setShow('');
                      }}
                    />
                  )}
                  {['add', 'edit'].includes(rightData['mode']) && (
                    <div>
                      <ValidationTPAddComponent
                        data={rightData?.data}
                        list={rightData?.list}
                        mode={rightData?.mode}
                        changeHandler={(data: any) => {
                          if (rightData['mode'] === 'edit' && data != null) {
                            data = { ...data, id: rightData['id'] };
                          }
                          onCloseRight(data, rightData['type'], rightData['mode'], actionData['id']);
                        }}
                      />
                    </div>
                  )}
                </>
              )}
              {show === 'validateTP' && (
                <ImpactAnalysisModalComponent
                  data={validateTPData['validateData']}
                  currentTP={actionData['id']}
                  parentTP={parentTP}
                  close={(tpName: string) => {
                    repTechnicalProfile(tpName);
                    setShow('');
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

// export default withAITracking(reactPlugin, TechnicalProfile);
export default TechnicalProfile;
